import React from "react";
import Window from "../assets/ipillion/Window";
import { useTranslations } from "next-intl";
import WhiteArrow from "../projects/ezcredit/icons/WhiteArrow";
import { useRouter } from "next/router";
import Link from "next/link";
const Auctions = ({ text, icon, color, link }) => {
  const t = useTranslations("ipillion.Auctions");
  const router = useRouter();
  const lang = router.locale;
  return (
    <>
      <div className="h-[75px]  flex justify-between relative my-5">
        <div className="lg:w-[100%] z-10 w-[95%]  lg:h-[96px] h-[75px] mb-[108px]  shadow-[_0px_-2px_11px_rgba(0,0,0,0.02)] bg-[#F6F6F6] rounded-[20px] flex ">
          <div className="  flex w-[90%] m-auto justify-between items-center ">
            <div className="flex items-center w-full justify-between ">
              <div className="relative  lg:w-[250px] w-full   lg:h-[96px] h-[75px]">
                <div
                  style={{ backgroundColor: color }}
                  className={` absolute left-0  bottom-0 lg:w-[219px] lg:h-[128px] w-[120px] h-[90px]  flex justify-center items-center rounded-t-[16px]`}
                >
                  <label>{icon}</label>
                </div>
              </div>

              <h3
                className={`${
                  lang == "ar" ? "mr-8 lg:mr-16" : "ml-8 lg:ml-16"
                } lg:text-[24px] w-full text-[18px]  text-[#010140] font-bold`}
              >
                {text}
              </h3>
            </div>
            <button></button>
            <Link href={`${link}`}>
              <button className="custom-rounded-border w-[160px] h-[48px] leading-6 hidden lg:block	">
                {t("button")}
              </button>
            </Link>
          </div>
        </div>

        <Link href={`${link}`}>
          <div className="relative lg:hidden hover:cursor-pointer">
            <div
              className={` ${
                lang == "ar" ? "left-0" : "right-0"
              } absolute w-[150px] h-[98%] bottom-[1%] bg-gradient-to-tr from-[#2EBBFF] via-[#FE17FF] to-[#6232EA] rounded-[20px]`}
            >
              <div
                className={`${
                  lang == "ar" ? "left-1 -scale-x-100" : "right-1"
                } absolute  flex justify-center items-center h-full`}
              >
                <WhiteArrow />
              </div>
            </div>
          </div>
        </Link>
      </div>
    </>
  );
};

export default Auctions;
